import { ReactNode } from 'react';

export enum NotificationTheme {
  Warning = 'warning',
  Success = 'success',
}

export interface IOuter {
  theme: NotificationTheme;
  label: ReactNode;
  dataHook?: string;
  onClose: () => void;
  onCloseButtonClick: () => void;
}
